import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/hd49XcQQXdBfWYLHLNAsN4/ChatGPT_Image_11_sept_2026__15_26_24-removebg-preview.webp';
export function Hero() {
  return <section id="hero" className="w-full bg-gradient-to-b from-mint to-mint-dark px-6 py-16 sm:px-10 lg:py-20" data-id="element-82" data-mp="4m8nkg2xoxmi">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-83" data-mp="128607wumu8qj">
        <h1 className="font-heading text-4xl font-bold leading-tight text-white sm:text-5xl" data-id="element-84" data-mp="nc88cqrqrqk4">
          ¿Cansada de la hinchazón y estar sin energía?
        </h1>

        <p className="mt-6 text-base text-white/90 sm:text-xl" data-id="element-85" data-mp="3d33ecx6girk8">
          Dile adiós a la inflamación con <span className="font-semibold text-white" data-id="element-86" data-mp="380vyvxmf4td5">245 recetas antiinflamatorias</span> que
          te hacen sentir liviana desde el primer día
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} src={MOCKUP_URL} alt="Pack completo Barriga Plana: 6 tomos de recetas antiinflamatorias más 5 bonos" className="mt-8 h-auto w-full max-w-[360px] sm:max-w-[420px]" data-id="element-87" data-mp="3o85bzdbr655m" />

        <a href="#comprar" className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-coral px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-coral-dark sm:w-auto sm:min-w-[300px]" data-id="element-88" data-mp="3599i633t3ssb">
          Acceso Ahora — 17,99€
        </a>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/90" data-id="element-89" data-mp="2hk83vz8alnf4">
          <span className="flex items-center gap-1.5" data-id="element-90" data-mp="2ljgzzaqt1xdu">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="s1rr4kwyw0sp" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-92" data-mp="nbl3ooe6ymc1">
            <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="na08cwk1yzd4" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-94" data-mp="icrs51igt5ei">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="ddnf1zsf6niw" /> Pago seguro
          </span>
        </div>
      </motion.div>
    </section>;
}